"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const propertyBackDefault_webp_1 = __importDefault(require("../../../../../assets/images/propertyBackDefault.webp"));
const Properties_1 = require("../../../../../hooks/Properties");
const Amenities_1 = __importDefault(require("../amenities/Amenities"));
const ReserveDetail_1 = __importDefault(require("../reserveDetail/ReserveDetail"));
require("./Card.scss");
const CardStyles_1 = require("./CardStyles");
const logo_suites_icon_webp_1 = __importDefault(require("../../../../../assets/images/logo_suites_icon.webp"));
const airbnb_icon_webp_1 = __importDefault(require("../../../../../assets/images/airbnb-icon.webp"));
const InstructionsCheckin_1 = __importDefault(require("../instructionsCheckin/InstructionsCheckin"));
const BookAgain_1 = __importDefault(require("../bookAgain/BookAgain"));
const ConfirmCheckout_1 = __importDefault(require("../confirmCheckout/ConfirmCheckout"));
const dates_1 = require("../../../../../utils/dates");
const numbers_1 = require("../../../../../utils/numbers");
const CannotCheckout_1 = __importDefault(require("../cannotCheckout/CannotCheckout"));
const bookingStatus = Object.freeze({
    STATUS_CONFIRMED: {
        status: 1,
        name: 'CONFIRMED',
        description: 'Confirmada',
    },
    STATUS_REQUEST: {
        status: 3,
        name: 'REQUEST',
        description: 'Pagamento pendente',
    },
    STATUS_CANCELLED: {
        status: 0,
        name: 'CANCELLED',
        description: 'Cancelada',
    },
    STATUS_FINISHED: {
        status: 4,
        name: 'FINISHED',
        description: 'Finalizada',
    },
});
const Card = props => {
    var _a;
    const { reserve, reloadBookings } = props;
    const [modalActive, setModalActive] = (0, react_1.useState)('default');
    const [isModalConfirmCheckout, setModalConfirmCheckout] = (0, react_1.useState)(false);
    const propContext = (0, Properties_1.useProperties)();
    const history = (0, react_router_dom_1.useHistory)();
    const handleOpenModal = (wich) => {
        setModalActive(wich);
    };
    const modalFactory = {
        amenities: react_1.default.createElement(Amenities_1.default, { roomId: reserve.roomId, name: reserve.roomName }),
        reserveDetail: react_1.default.createElement(ReserveDetail_1.default, null),
        instructions: react_1.default.createElement(InstructionsCheckin_1.default, { reserve: reserve }),
        bookAgain: react_1.default.createElement(BookAgain_1.default, null),
        cannotCheckout: react_1.default.createElement(CannotCheckout_1.default, { statusPayment: reserve.statusPayment }),
    };
    const getPropertyImage = (propertyName) => {
        var _a, _b;
        if (propContext.properties && !!propContext.properties.length) {
            const propertyImage = (_a = propContext === null || propContext === void 0 ? void 0 : propContext.properties.find(property => property.name.toLowerCase() === propertyName.toLowerCase())) === null || _a === void 0 ? void 0 : _a.images;
            return ((_b = propertyImage === null || propertyImage === void 0 ? void 0 : propertyImage[0]) === null || _b === void 0 ? void 0 : _b.url) || propertyBackDefault_webp_1.default;
        }
        return propertyBackDefault_webp_1.default;
    };
    const getBookingStatus = (status) => {
        return Object.values(bookingStatus).find(s => s.status === status) || bookingStatus.STATUS_FINISHED;
    };
    const genTextDecoration = (status, simpleText) => {
        const statusCode = getBookingStatus(status);
        switch (statusCode) {
            case bookingStatus.STATUS_CONFIRMED:
                return {
                    color: '#69B843',
                    fontWeight: '500',
                    exitColor: '#c7305a',
                };
            case bookingStatus.STATUS_REQUEST:
                return {
                    color: simpleText ? '#000' : '#f6cf0a',
                    fontWeight: '500',
                };
            default:
                return {
                    color: '#000',
                    fontWeight: '500',
                };
        }
    };
    const { color, fontWeight, exitColor = '#000' } = genTextDecoration(reserve.status);
    const genRefererIcon = {
        site360suites: logo_suites_icon_webp_1.default,
        Airbnb: airbnb_icon_webp_1.default,
        get getIcon() {
            const { refererEditable, site360suites } = this;
            return refererEditable || site360suites;
        },
    };
    const getPropertyId = (propertyName) => {
        var _a;
        if (propContext.properties && !!propContext.properties.length) {
            const propertyId = (_a = propContext === null || propContext === void 0 ? void 0 : propContext.properties.find(property => property.name.toLowerCase() === propertyName.toLowerCase())) === null || _a === void 0 ? void 0 : _a.propId;
            return propertyId ? propertyId === null || propertyId === void 0 ? void 0 : propertyId.toString() : '0';
        }
        return '0';
    };
    const isCheckoutAvailable = (0, react_1.useMemo)(() => {
        const isCheckoutDateIsValid = (0, dates_1.checkIsDateBetweenDates)(reserve.checkIn, reserve.checkOut, (0, dates_1.Today)());
        return isCheckoutDateIsValid && (reserve.status === 1 || reserve.status === 4) && reserve.activeCheckout;
    }, [reserve]);
    const isDescriptionAvailable = (0, react_1.useMemo)(() => {
        var _a;
        const isArray = Array.isArray(reserve.roomTexts);
        const isArrayEmpty = (_a = reserve.roomTexts) === null || _a === void 0 ? void 0 : _a.length;
        return isArrayEmpty && isArray;
    }, [reserve]);
    const handleOpenPreCheckin = (bookid, propName) => {
        history.push(`/checkin?bookId=${bookid}&propId=${getPropertyId(propName)}`);
    };
    const handleReserveAgain = (roomId, propName) => {
        const propId = getPropertyId(propName);
        history.push(`/reserva?property=[${propId}]?open=true`, {
            roomId,
            propId,
        });
    };
    const handleShowMessage = () => {
        setModalActive('bookAgain');
    };
    const handleHideCheckoutModal = () => setModalConfirmCheckout(false);
    const handleShowCheckoutModal = () => setModalConfirmCheckout(true);
    const cardContent = (react_1.default.createElement("div", null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("img", { className: "prop-image", src: getPropertyImage(reserve.propertyName), alt: "imagem do quarto", loading: "lazy" })),
        react_1.default.createElement("div", { className: "card-content" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", { className: "title" }, reserve.propertyName),
                react_1.default.createElement("span", { className: "room-description" }, isDescriptionAvailable ? reserve.roomTexts[0].roomDescription1 : '')),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "child" },
                    react_1.default.createElement("span", null, "H\u00F3spedes"),
                    react_1.default.createElement("span", null,
                        reserve.numAdult,
                        react_1.default.createElement("span", null, "\u00A0h\u00F3spedes"))),
                react_1.default.createElement("div", { className: "child" },
                    react_1.default.createElement("span", null, "Su\u00EDtes"),
                    react_1.default.createElement("span", null, reserve.roomQty)),
                react_1.default.createElement("div", { className: "child" },
                    react_1.default.createElement("span", null, "Status da Reserva"),
                    react_1.default.createElement("span", { style: { color, fontWeight: +fontWeight } }, getBookingStatus(reserve.status).description)),
                react_1.default.createElement("div", { className: "child" },
                    react_1.default.createElement("span", null, "Di\u00E1rias"),
                    react_1.default.createElement("span", null, (0, dates_1.getDiffDaysBetweenDates)(reserve.checkIn, reserve.checkOut))),
                react_1.default.createElement("div", { className: "child" },
                    react_1.default.createElement("span", null, "Entrada"),
                    react_1.default.createElement("span", { style: { color, fontWeight: +fontWeight } }, (0, dates_1.formatDateToView)(reserve.checkIn))),
                react_1.default.createElement("div", { className: "child" },
                    react_1.default.createElement("span", null, "Sa\u00EDda"),
                    react_1.default.createElement("span", { style: { color: exitColor, fontWeight: +fontWeight } }, (0, dates_1.formatDateToView)(reserve.checkOut)))),
            react_1.default.createElement("div", { className: "row", id: "reserveContainer" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", null, "Valor da Reserva"),
                    react_1.default.createElement("span", null, `${(0, numbers_1.formatCurrency)(reserve.totalPrice)}`)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", null, "N\u00FAmero da reserva"),
                    react_1.default.createElement("span", null, reserve.bedsBookId))))));
    return (react_1.default.createElement("div", { className: "Card" },
        react_1.default.createElement("div", { className: "card-container" },
            react_1.default.createElement("div", { className: "platform-icon" },
                react_1.default.createElement("img", { src: genRefererIcon.getIcon, alt: "icon" })),
            cardContent),
        react_1.default.createElement("div", { className: "btn-section" },
            react_1.default.createElement(antd_1.Button, { type: "default", className: "guestDataBtn", onClick: () => handleOpenPreCheckin(reserve.bedsBookId, reserve.propertyName) }, "Dados do h\u00F3spede"),
            react_1.default.createElement(antd_1.Button, { type: "default", className: ((_a = reserve.checkInInstructions) === null || _a === void 0 ? void 0 : _a.showCheckInInstructions)
                    ? 'instructions-checkin'
                    : 'instructions-checkin-disabled', onClick: () => handleOpenModal('instructions') }, "Instru\u00E7\u00F5es de Check-in"),
            react_1.default.createElement(antd_1.Button, { type: "default", className: isCheckoutAvailable ? 'instructions-checkin' : 'instructions-checkin-disabled', onClick: () => {
                    isCheckoutAvailable ? handleShowCheckoutModal() : handleOpenModal('cannotCheckout');
                } }, "Realizar Check-out"),
            reserve.bookAgain !== undefined && (react_1.default.createElement(antd_1.Button, { type: "primary", className: `${!reserve.bookAgain && 'instructions-checkin-disabled'} book-again`, onClick: reserve.bookAgain ? () => handleReserveAgain(reserve.roomId, reserve.propertyName) : handleShowMessage }, "Reservar Novamente"))),
        react_1.default.createElement(CardStyles_1.StyledModal, { onOk: () => setModalActive('default'), onCancel: () => setModalActive('default'), visible: !!modalFactory[modalActive], destroyOnClose: true, centered: true, footer: null, width: 900 }, modalFactory[modalActive]),
        react_1.default.createElement(antd_1.Modal, { visible: isModalConfirmCheckout, footer: null, centered: true, closable: false },
            react_1.default.createElement(ConfirmCheckout_1.default, { bookId: reserve.bedsBookId, propertyId: reserve.propertyId, reloadBookings: reloadBookings, close: handleHideCheckoutModal }))));
};
exports.default = Card;
